import React, { useState, useEffect } from "react";

const PdfViewer = ({ file, dataURI }) => {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {

    if (dataURI) {
      setPdfUrl(dataURI);
      return;
    }
    if (file) {
      const url = URL.createObjectURL(file);
      setPdfUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    }
    setPdfUrl(null);
  }, [file, dataURI]);

  return (
    <div style={{ width: "100%", height: "800px", border: "1px solid #ccc" }}>
      {pdfUrl ? (
        <iframe
          src={pdfUrl}
          title="PDF Viewer"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      ) : (
        <p>No PDF selected</p>
      )}
    </div>
  );
};

export default PdfViewer;
